import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from "react-router-dom";
import moment from 'moment';

const readCookie = require('../cookie.js').readCookie;

let year = moment().year();
const years = [];
for (var i = -3; i < 10; i++) {
	var yearStr = (year - i) + '-' + (year - i + 1);
	years.push(yearStr);
}

export default class IMProjectsSidebar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			goals: [],
			projectCategories: [],
			locations: [],
			address: '',
			goalID: '',
			date: this.props.filters.fiscalYear,
			proj_category: ''
		}
	}

	componentWillMount() {
		fetch(process.env.REACT_APP_MIS_API_URL + '/getOtAttributes', {
			method: "GET",
			headers: {
				'Auth': JSON.parse(readCookie('mis_data')).access_token
			}
		})
			.then((data) => data.json())
			.then((data) => {
				fetch(process.env.REACT_APP_MIS_API_URL + '/ngo/mis/project?=location', {
					method: 'GET',
					headers: {
						'Auth': JSON.parse(readCookie('mis_data')).access_token
					}
				})
					.then((data) => data.json())
					.then((data) => {
						this.setState({ locations: data.locations });
					}).catch(err => {
						console.log("err", err)
					})

				var goals = [], allAgendas = [], beneficiaries = [], locationTypes = [];
				for (var i = 0; i < data.otAttributes.length; i++) {
					if (data.otAttributes[i].type === 'goal') goals.push(data.otAttributes[i]);
					else if (data.otAttributes[i].type === 'agenda') allAgendas.push(data.otAttributes[i]);
					else if (data.otAttributes[i].type === 'beneficiary') beneficiaries.push(data.otAttributes[i]);
					else if (data.otAttributes[i].type === 'setting') locationTypes.push(data.otAttributes[i]);
					this.setState({ goals, allAgendas, beneficiaries, locationTypes });
				}
			}).catch(err => {
				console.log("err", err)
			})

		fetch(process.env.REACT_APP_MIS_API_URL + '/ngo/' + JSON.parse(readCookie('mis_data')).data._organisationId + '/project-categories', {
			method: "GET",
			headers: {
				'Auth': JSON.parse(readCookie('mis_data')).access_token
			}
		}).then((data) => data.json())
			.then((data) => {
				this.setState({ projectCategories: data.data });
			}).catch(err => {
				console.log("err", err)
			});
	}

	locationFilter(event) {
		this.setState({ address: event.target.value })
		this.props.onFiltersChange('location', event);
	}
	goalFilter(event) {
		this.setState({ goalID: event.target.value });
		this.props.onFiltersChange('goalId', event)
	}
	dateFilter(event) {
		this.setState({ date: event.target.value });
		this.props.onFiltersChange('fiscalYear', event);
	}
	projectSelect(event) {
		this.setState({ proj_category: event.target.value });
		this.props.onFiltersChange('projectCategoryId', event);
	}
	clearFilter(event) {
		this.setState({
			address: '',
			goalID: '',
			date: this.props.getFiscalYear(),
			proj_category: ''
		});
		this.props.onFiltersChange('clearFilter', event);

	}

	render() {
		return (
			<div className="im-projects-sidebar">
				<ul className="projects-sidebar-filters">
					<button className="btn btn-danger clear-filter-btn" onClick={this.clearFilter.bind(this)}>
						Clear Filter
					</button>
					<li className="projects-sidebar-filter-container form-group">
						<span className="heading control-label">Select Location</span>
						<select className="fiscal-year-selector form-control" value={this.state.address} onChange={this.locationFilter.bind(this)}>
							<option className="location-option" value='' disabled>Select Location</option>
							{_.map(this.state.locations, (location, index) => {
								return (
									<option className="location-option" key={index + "location"} value={location.address}>{location.address}</option>
								)
							})}
						</select>
					</li>
					<li className="projects-sidebar-filter-container form-group">
						<span className="heading control-label">Select Fiscal Year</span>
						<select className="fiscal-year-selector form-control" value={this.state.date} onChange={this.dateFilter.bind(this)}>
							{years.map(function (year, index) {
								return (
									<option className="fiscal-year-option" key={index} value={year}>{year}</option>
								)
							})}
						</select>
					</li>
					<li className="projects-sidebar-filter-container form-group">
						<span className="heading control-label">Search</span>
						<input className="form-control" type="text" value={this.props.filters.searchText}
							onChange={this.props.onFiltersChange.bind(this, 'searchText')} placeholder="Search..." />
					</li>
					<li className="projects-sidebar-filter-container form-group">
						<span className="heading control-label">Goal</span>
						<select className="goal-selector form-control" value={this.state.goalID} onChange={this.goalFilter.bind(this)}>
							<option className="goal-option" value='' disabled>Select Goal</option>
							{this.state.goals.map(function (goal, index) {
								return (
									<option className="goal-option" value={goal._id} key={index}>{goal.name}</option>
								)
							})}
						</select>
					</li>
					<li className="projects-sidebar-filter-container form-group">
						<span className="heading control-label">Project Category</span>
						<select className="project-category-selector form-control" value={this.state.proj_category} onChange={this.projectSelect.bind(this)}>
							<option className="project-category-option" value='' disabled>Select Project Category</option>
							{this.state.projectCategories.map(function (projectCategory, index) {
								return (
									<option className="project-category-option" value={projectCategory.id} key={index}>{projectCategory.name}</option>
								)
							})}
						</select>
					</li>
					<li className="projects-sidebar-filter-container form-group">
						<span className="heading control-label">Status</span>
						<div className="status-filter-container">
							<label className="label-container">All
							  <input type="radio" name="project-status" checked={this.props.filters.status === 'All' ? true : false}
									onChange={this.props.onFiltersChange.bind(this, 'status', 'All')} />
								<span className="checkmark"></span>
							</label>
							<label className="label-container">Funded
							  <input type="radio" name="project-status" checked={this.props.filters.status === 'Funded' ? true : false}
									onChange={this.props.onFiltersChange.bind(this, 'status', 'Funded')} />
								<span className="checkmark"></span>
							</label>
							<label className="label-container">Submitted
							  <input type="radio" name="project-status" checked={this.props.filters.status === 'Submitted' ? true : false}
									onChange={this.props.onFiltersChange.bind(this, 'status', 'Submitted')} />
								<span className="checkmark"></span>
							</label>
							<label className="label-container">Draft
							  <input type="radio" name="project-status" checked={this.props.filters.status === 'Draft' ? true : false}
									onChange={this.props.onFiltersChange.bind(this, 'status', 'Draft')} />
								<span className="checkmark"></span>
							</label>
							{/* <label className="label-container">Completed
							  <input type="radio" name="project-status" checked={this.props.filters.status === 'Completed' ? true : false}
							  	onChange={this.props.onFiltersChange.bind(this, 'status', 'Completed')} />
							  <span className="checkmark"></span>
							</label> */}
						</div>
					</li>
				</ul>
				<div className="projects-sidebar-footer">
					<a href="https://www.letsendorse.com" target="_blank">
						<img src="/images/le_black.png" width="150" />
					</a>
				</div>
			</div>
		);
	}
}